<template>
    <div class="row py-3 bt-dash">
        <h6 class="f-w-700 my-3">{{ t('Product Group') }}</h6>
        <div class="custom-scrollbar list-container px-3 nav-link" style=" height: 50dvh;">
            <div class=" text-center text-white rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center gap-2"
                @click="onProductGroupClick(item.id)"
                :style="{ backgroundColor: item.appearance.buttonColor, boxShadow: findOnSelectedProductGroup(item.id) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }"
                style="grid-column: span 1 / span 1; height: 112px;" v-for="item in productGroupMock">
                <img v-if="item?.appearance?.image" :src="item.appearance.image" alt="department image"
                    class="object-fit-cover w-25 ratio1-1 border-0" />
                <h5 class=" text-white" :style="{ fontSize: calcFontSize(item.appearance.fontSizes) }">
                    {{ item.name }}</h5>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, computed, watch } from 'vue'
import { LinkGroups } from '@/store/management/productsStore'
import { useProductsStore } from '@/store/management/productsStore';
import { useProductGroupsStore } from '@/store/management/productGroupsStore';

import { useI18n } from 'vue-i18n'
import { productLinkGroupsLanguage } from '@/core/locales/products-language'

const { t } = useI18n({
  messages: productLinkGroupsLanguage
})

const productStore = useProductsStore()
const productGroupsStore = useProductGroupsStore()

const compState = reactive({
    selectedProductGroup: [] as LinkGroups[],
})

onMounted(() => {
    productGroupsStore.initializeProductGroups();
});

const productGroupMock = computed((): LinkGroups[] => 
    productGroupsStore.productGroupList.map((group: any) => ({
        ...group,
        appearance: {
            displayMode: group.appearance.displayMode ?? '',
            ...group.appearance,
        }
    }))
);

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        compState.selectedProductGroup = tempActiveProduct.value?.linkGroups || [] as LinkGroups[]
    }
})

watch(activeProductId, (newVal) => {
    if (tempActiveProduct.value?.basic.productNumber) {
        compState.selectedProductGroup = activeProduct.value?.linkGroups || [] as LinkGroups[]
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        linkGroups: newVal.selectedProductGroup
    })
}, { deep: true });

const findOnSelectedProductGroup = (id: string) => {
    return compState.selectedProductGroup.find((productGroup) => productGroup.id === id)
}

const calcFontSize = (fontSize: string) => {
    return fontSize === 'X-Large' ? '1.5rem' : fontSize === 'Large' ? '1.25rem' : fontSize === 'Medium' ? '1rem' : '0.875rem'
}

const onProductGroupClick = (id: string) => {
    const productGroup = productGroupMock.value.find((productGroup: { id: string; }) => productGroup.id === id)
    if (findOnSelectedProductGroup(id)) {
        compState.selectedProductGroup = compState.selectedProductGroup.filter((productGroup) => productGroup.id !== id)
    } else {
        if (productGroup) {
            compState.selectedProductGroup.push(productGroup)
        }

    }
}
</script>

<style lang="scss" scope>
.list-container {
    display: grid !important;
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    gap: 1rem;
}
</style>